import { render, staticRenderFns } from "./PollNav.vue?vue&type=template&id=30189442&scoped=true&"
import script from "./PollNav.vue?vue&type=script&lang=ts&"
export * from "./PollNav.vue?vue&type=script&lang=ts&"
import style0 from "./PollNav.vue?vue&type=style&index=0&id=30189442&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30189442",
  null
  
)

export default component.exports